/*
MIT License

Copyright (c) 2023 Artem Churyukin

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.
*/

const _templates=new Map();
const _helpers=new Map([['_',()=>{}]]); //TODO

const _templates_get=(name)=>_templates.get(name);
const _helpers_get=(name)=>_helpers.get(name);

function _add_template(uid,str){
	if(_templates.has(uid)) return _templates.get(uid);
	const func=_compile(str);
	
	_templates.set(uid,func);
	
	return func;
}

function _render(str,data){
	return _compile(str)(data);
}

function _compile(str){
	return eval(`((_t,_h,_={})=>(${_parse(str).replace(/\t|\n/g,'')}))`).bind(this,_templates_get,_helpers_get);
}

function _test(str){
	return str.indexOf("{{")!==-1;
}

function _add_helper(uid,func){
	_helpers.set(uid,func);
}

function _get_end(str,level=2,opener='{',closer='}'){
	for(let i=0;i<str.length;i++){
		if(level===0) return i;
		if(str.substr(i,opener.length)===opener){
			level++;
			i+=opener.length-1;
		}
		if(str.substr(i,closer.length)===closer){
			level--;
			i+=closer.length-1;
		}
	}
	
	return str.length;
}

const blocks=[
	{open:'"',close:'"'},
	{open:"'",close:"'"},
	{open:'`',close:'`'},
	{open:'(',close:')'},
	{open:'{',close:'}'},
	{open:'[',close:']'},
];

function _parse_arguments(str){
	str=str.trim();
	
	const args=[''];
	
	const levels=[];
	
	for(let i=0;i<str.length;i++){
		//Either it's a closer for the level
		if(levels.length && str[i]===levels[levels.length-1].close){
			args[args.length-1]+=str[i];
			levels.pop();
		} else {
			let new_level;
			blocks.forEach(block=>{
				if(str[i]===block.open) new_level=block;
			});
			if(new_level){
				levels.push(new_level);
				args[args.length-1]+=str[i];
			} else if(str[i]===' '){
				if(levels.length===0){
					args.push('');
				} else {
					args[args.length-1]+=str[i];
				}
			} else {
				args[args.length-1]+=str[i];
			}
		}
	}
	
	return args.filter(el=>!!el).map(el=>_parse_argument(el.trim()));
}

const _bool=new Set(['true','false']);

function _parse_reference(str,f,s=true){
	str=str.trim();
	if(str.match(/^\d\.?\d*$/g)){
		return str;
	} else if(_bool.has(str.toLowerCase())){
		return str;
	} else {
		return `${f?'${':''}_.${str.replace(/\./g,'?.').replace(/`/g,'\\`')}${s?'||""':''}${f?'}':''}`;
	}
}

function _parse_argument(arg){
	if(arg[0]==='('){
		
		let str=arg.substr(1,arg.length-2);
		
		while(str[0]===' ') str=str.substr(1);
		
		let potential_helper=str.split(' ')[0];
		
		if(_helpers.has(potential_helper.trim())){
			const helper=potential_helper.trim();
			
			//TODO parse args char by char to avoid spaces inside JSON's or helper's calls.
			const args=_parse_arguments(str.substr(potential_helper.length).trim());
			
			return `_h("${helper}")(${args.join(',').replace(/`/g,'\\`')})||""`;
		}
	} else {
		let new_level;
		blocks.forEach(block=>{
			if(arg[0]===block.open) new_level=block;
		});
		if(!new_level){
			return _parse_reference(arg);
		}
	}
	
	return arg;
}

function _parse_json(json){
	for(let i=0;i<json.length;i++){
		if(json[i]==='('){
			const end=_get_end(json.substr(i+1),1,'(',')');
			const parsed=_parse_argument(json.substr(i,end+1));
			json=json.slice(0,i)+parsed+json.slice(i+end+1);
			i+=parsed.length;
		}
	}
	
	return json;
}

function _find_else(str){
	let next_if=str.indexOf("{{#if");
	let next_else=str.indexOf("{{else}}");
	
	if(next_else===-1) return -1;

	if(next_if===-1 || next_if>next_else) return next_else;
	
	let index=0;
	
	let rest=str;
	
	while(true){ //Bad idea
		index+=next_if+5;
		rest=rest.substr(next_if+5);
		let end=_get_end(rest,1,'{{#if','{{/if}}');
		index+=end;
		rest=rest.substr(end);
		
		next_if=rest.indexOf("{{#if");
		next_else=rest.indexOf("{{else}}");
		
		if(next_else===-1) return -1;

		if(next_if===-1 || next_if>next_else) return index+next_else;
	}
	
	return -1;
}

function _parse_if_body(str=""){
	let else_index=_find_else(str);
	if(else_index===-1) return `${_parse(str)}:""`;
	
	return `${_parse(str.substr(0,else_index))}:${_parse(str.substr(else_index+8))}`;
}

function _parse(str=''){
	let rest=str;
	
	let res=`\``;
	
	let next_expr=rest.indexOf('{{');
	
	while(next_expr!=-1){
		if(next_expr>0) res+=rest.slice(0,next_expr);
		
		rest=rest.substr(next_expr+2);
		
		let end=_get_end(rest);
		let body=rest.slice(0,end-2).trim();
		rest=rest.substr(end);
		
		if(body[0]==='#'){
			body=body.substr(1);
			while(body[0]===' ') body=body.substr(1);
			
			let potential_complex=body.split(' ')[0];
			
			switch(potential_complex.trim()){
				case 'if':
					let if_end=_get_end(rest,1,'{{#if','{{/if}}');
					res+=`\${${_parse_reference(body.substr(potential_complex.length).trim(),false,false)}?${_parse_if_body(rest.substr(0,if_end-7))}}`;
					rest=rest.substr(if_end);
				break;
				case 'each':
					let each_end=_get_end(rest,1,'{{#each','{{/each}}');
					res+=`\${${_parse_reference(body.substr(potential_complex.length).trim(),false,false)}.map((_)=>(${_parse(rest.substr(0,each_end-9))})).join('')}`;
					rest=rest.substr(each_end);
				break;
			}
			
		} else if(body[0]==='>'){
			body=body.substr(1);
			while(body[0]===' ') body=body.substr(1);
			let potential_template=body.split(' ')[0];
			
			const template=potential_template.trim();
			
			const args=_parse_json(body.substr(potential_template.length).trim());
			
			res+=`\${_t("${template}")(${args.replace(/`/g,'\\`')})}`;
			
		} else {
			//Helper or just output.
			let potential_helper=body.split(' ')[0];
			
			if(_helpers.has(potential_helper.trim())){
				const helper=potential_helper.trim();
				
				const args=_parse_arguments(body.substr(potential_helper.length).trim());
				
				res+=`\${_h("${helper}")(${args.join(',').replace(/`/g,'\\`')})||""}`;
			} else {
				res+=_parse_reference(body,true);
			}
		}
		
		
		next_expr=rest.indexOf('{{');
	}
	
	res+=`${rest}\``;
	
	return res;
}

export default {
	templates:{
		add:_add_template,
		compile:_compile,
		render:_render,
		test:_test,
	},
	helpers:{
		add:_add_helper
	}
};
